export default "__VITE_ASSET__b52f260e__"